// extracted by mini-css-extract-plugin
export default {"data__container":"DataContainer_data__container__up1gK"};